// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WMjEg6zwEJc_B4YPEv9I{display:grid;place-items:center}.oJZGAdaM6HlmZhRpcZx7{width:100vw;height:100vh}", "",{"version":3,"sources":["webpack://./src/shared/ui/triangle-loader/triangle-loader.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CAGF,sBACE,WAAA,CACA,YAAA","sourcesContent":[".wrapper {\n  display: grid;\n  place-items: center;\n}\n\n.fullScreen {\n  width: 100vw;\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "WMjEg6zwEJc_B4YPEv9I",
	"fullScreen": "oJZGAdaM6HlmZhRpcZx7"
};
export default ___CSS_LOADER_EXPORT___;
